import { Component, Inject } from '@angular/core';
import { ButtonsComponent } from '../../../shared/buttons/buttons.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DropdownComponent } from '../../../shared/dropdown/dropdown.component';
import { SvTestPannelService } from '../../../services/sv-test-pannel/sv-test-panel.service';
import { CreatePanelJobReqBody, ExtendedModalData } from '../../../interfaces/sv-test-pannel';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-sv-test-create-panel',
  standalone: true,
  imports: [
    ButtonsComponent,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    DropdownComponent,
    CommonModule,
  ],
  templateUrl: './sv-test-create-panel.component.html',
  styleUrl: './sv-test-create-panel.component.css',
})
export class SvTestCreatePanelComponent {
  cancelBtnLabel: string = $localize`Cancel`;
  doneBtnLabel: string = $localize`Done`;
  dropdownOptions: Array<{ value: any; label: string }> = [];
  selectionValue: string = '';
  selectFastaFileCntrl = new FormControl('', [Validators.required]);
  dropdownLabel: string = $localize`Select File`;
  versionDropdownLabel: string = $localize`Select App Version`;
  versionDropdownOptions: Array<any> = [];
  selectedVersion: string = '';
  selectVersionCntrl = new FormControl<number | null>(null);
  isErrorVisible: boolean = false;
  errorMessage: string = '';
  isSubmitting: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SvTestCreatePanelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExtendedModalData,
    private svTestPannelService: SvTestPannelService
  ) {}

  ngOnInit() {
    this.svTestPannelService.getFastaList().subscribe({
      next: (response) => {
        if (response.success) {
          this.dropdownOptions = response.files.map((e: any) => ({
            value: e.file_name,
            label: e.file_name,
          }));
        } else {
          this.isErrorVisible = true;
          this.errorMessage = $localize`${response.message}`;
        }
      },
      error: (err) => {
        console.error('fasta list api failed:', err);
        this.isErrorVisible = true;
        this.errorMessage = $localize`Error while fetching list of fasta file.`;
      },
    });
    this.svTestPannelService.getVersions(this.data.inputType).subscribe({
      next: (response) => {
        if (response.success) {
          this.versionDropdownOptions = response.data.map((v: any) => ({
            value: v.AppVersionID,
            label: `${v.Name} v${v.Version}`,
          }));
        } else {
          // Non-blocking error, as version is optional
          console.warn('Could not fetch app versions:', response.message);
        }
      },
      error: (err) => {
        console.error('App versions API failed:', err);
      },
    });
  }

  closePopup() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.selectFastaFileCntrl.invalid || this.isSubmitting) {
      return; // Don't submit if required fields are missing
    }
    this.isSubmitting = true;
    let reqBody: CreatePanelJobReqBody = {
      panel_id: this.data.panelId,
      fasta_file_name: this.selectionValue,
    };
    if (this.selectVersionCntrl.value) {
      reqBody.version_id = this.selectVersionCntrl.value;
    }
    this.svTestPannelService
      .createJobSvTest(reqBody)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.dialogRef.close(true);
          } else {
            this.isErrorVisible = true;
            this.errorMessage = $localize`${response.message}`;
          }
        },
        error: (err) => {
          this.isErrorVisible = true;
          this.errorMessage = $localize`Error while creating jobs for SV test panel.`;
          console.error('pannel list api failed:', err);
        },
      });
  }
  handleValueChange(value: string) {
    this.selectionValue = value;
  }

  handleVersionChange(value: any) {}
}
